<div class="row">
  <div class="col">

    <div class="cm-card">
      <div class="cm-card-header">
        <div class="cm-header-title">
          <div class="d-flex ml-2">
            <button mat-raised-button color="primary"
                    [disabled]="!selection.selected.length"
                    (click)="blockAndUpdateStatus()" class="d-none d-md-block  mr-2">
              Block & update status
            </button>
            <button mat-raised-button color="primary"
                    [disabled]="!selection.selected.length"
                    (click)="updateStatus()" class="d-none d-md-block">
              Update status
            </button>
          </div>
        </div>
        <div class="cm-card-controls">
          <button mat-icon-button
                  color="primary"
                  matTooltip="Refresh"
                  (click)="refreshDataFirstPage()"
                  class="">
            <i class="fas fa-sync"></i>
          </button>
          <button mat-icon-button color="primary"
                  *ngIf="mailed"
                  matTooltip="Download"
                  (click)="exportData()" class="d-none d-md-block">
            <i class="fas fa-download"></i>
          </button>
          <button mat-icon-button color="primary"
                  (click)="filters.toggle()"
                  matTooltip="Filter">
            <i class="fas fa-filter" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="cm-card-content">
        
        <cm-card-filters #filters>
          <div class="col col-md-auto">
            <mat-form-field floatLabel="never" class="w-100">
              <input name="searchDomain" matInput
                     [value]="filter.name||''"
                     [formControl]="searchDomainFormControl"
                     placeholder="Filter by domain name">
            </mat-form-field>
          </div>
        </cm-card-filters>
        
        <div class="card-message" *ngIf="loadingData">
          <mat-spinner  [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
        </div>
        <div class="table-scroll-wrapper">
          <mat-table #table [dataSource]="dataSource" [hidden]="loadingData">
      
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef class="d-none d-md-flex">
                <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="d-none d-md-flex">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </mat-cell>
            </ng-container>
      
            <ng-container matColumnDef="domain">
              <mat-header-cell *matHeaderCellDef>Domain</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <!--<span class="mobile-label">Domain:</span>-->
                {{element.blockedDomain.domain}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="impressions">
              <mat-header-cell *matHeaderCellDef>Impressions</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Impressions:</span>
                {{element.impressions | number}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Status:</span>
                <mat-select placeholder="Status" [(ngModel)]="element.status">
                  <mat-option *ngFor="let status of statusesKL" [value]="status.key">
                    {{ status.label }}
                  </mat-option>
                </mat-select>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="createDateTime">
              <mat-header-cell *matHeaderCellDef>Time created</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Time created:</span>
                {{element.createDateTime | date : 'yyyy-MM-dd'}}
                <small class="d-block ml-2 ml-md-0">{{element.createDateTime | date: 'hh:mm a'}}</small>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="updateDateTime">
              <mat-header-cell *matHeaderCellDef>Time updated:</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Time updated:</span>
                {{element.updateDateTime | date : 'yyyy-MM-dd'}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="detectionType">
              <mat-header-cell *matHeaderCellDef>Detection type</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Detection type:</span>
                {{element.blockedDomain.detectionType}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="attachments">
              <mat-header-cell *matHeaderCellDef>Attach.</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Attachments:</span>
                <button mat-icon-button color="primary"
                        *ngIf="element.blockedDomain.attachments?.length"
                        (click)="openAttachmentsModal(element)">
                  <i class="fas fa-paperclip"></i>
                </button>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="adTrace">
              <mat-header-cell *matHeaderCellDef>Ad trace</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Ad trace:</span>
                <button mat-icon-button color="primary"
                        *ngIf="element.traces?.length"
                        (click)="openAdTraceModal(element)"
                        matTooltip="View Ad trace">
                  <i class="fas fa-list"></i>
                </button>
              </mat-cell>
            </ng-container>
      
            <ng-container matColumnDef="comment">
              <mat-header-cell *matHeaderCellDef class="d-flex justify-content-md-center">Comment</mat-header-cell>
              <mat-cell *matCellDef="let element" class="d-flex justify-content-md-center">
                <span class="mobile-label">Comment:</span>
                <cm-comment-button [readOnly]="false"
                                   (commentChange)="updateComment(element, $event)"
                                   [comment]="element.comment">
                </cm-comment-button>
              </mat-cell>
            </ng-container>
      
            <mat-header-row
              *matHeaderRowDef="columns"></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: columns;"></mat-row>
          </mat-table>
        </div>
      </div>
      <mat-card-footer [hidden]="loadingData" class="m-0">
        <mat-paginator #paginator
                       [pageSize]="20"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </mat-card-footer>
    </div>
  </div>
</div>
